import axios from "axios";

export const getCustomerEmail = async (
  senderCompany: string,
  isBusinessPartner: boolean
): Promise<string> => {
  const response = await axios.get("/api/email", {
    params: { senderCompany, isBusinessPartner },
  });
  return response.data;
};

export const getSupplierEmail = async (contextId: string): Promise<string> => {
  const response = await axios.get("/api/email/tier-n", {
    params: { contextId },
  });
  return response.data;
};
